import React from 'react';
import { TipsMapType } from '../index';
import { CONTACT_EMAIL } from '@op/constants';

export const keyOpinionsRisingTopics: TipsMapType = {
  en: 'Topics are ranked by their period-over-period growth rate in mention volume during the selected time period, and the top 3 with the highest growth rates and a minimum of 20 mentions are selected.',
  zh: '声量不少于20且所选时间段环比增长率最高的三个话题。',
};
export const keyOpinionsRisingKeywords: TipsMapType = {
  en: 'Keywords with a minimum mention of 10 (5 for hourly) and a growth rate exceeding 80% (40% for monthly).',
  zh: '声量不少于10条（小时环比为5条）且增长率大于80%（月环比为40%）的关键词。',
};

export const keyOpinionsAdvancedGPT: TipsMapType = {
  en: 'Receive a customized quantitative opinion analysis report and the corresponding original reviews on your current filter settings.',
  zh: '需中文...',
};

export const keyOpinionsGetAdvancedGPT: TipsMapType = {
  en: 'To optimize efficiency, this section will reuse an existing advanced AI summary generated under identical filters within the last hour.',
  zh: '若相同筛选条件下，高级AI总结已在近一小时内成功生成，此处将直接复用该份总结。',
};

export const keyOpinionsGPTSummary: TipsMapType = {
  en: (
    <>
      Daily AI summaries are routinely generated for some games （Based on all
      reviews after invalid data is removed）, please contact {CONTACT_EMAIL}{' '}
      for routine generation requests
      <br />
      <br />
      Click the &quot;Reset&quot; button above and select a single day to view
      the routine report generated in history（Starting from 2024-11-13）
    </>
  ),
  zh: (
    <>
      仅部分游戏例行生成每日AI总结(基于去除无效数据后的全部评论)，如有例行生成需求，请联系
      {CONTACT_EMAIL}
      <br />
      <br />
      点击上方&quot;重置&quot;按钮，选择单日，可查看历史生成的例行报告（从2024-11-13开始）
    </>
  ),
};

export const keyOpinionsGPTSummaryTips: TipsMapType = {
  en: 'No mentions data available for the current selection.',
  zh: '当前选项下暂无声量。',
};
